import { render, staticRenderFns } from "./userMoneyList.vue?vue&type=template&id=f000f476"
import script from "./userMoneyList.vue?vue&type=script&lang=js"
export * from "./userMoneyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports